var map = {
	"./production.json": 952,
	"./staging.json": 953
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 951;


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/2c-site_feature_UD-661_Chat-2025/content nonrecursive \.json$
// module id = 951
// module chunks = 74